// src/index.js
import CameraRecorder from './components/CameraRecorder.vue';

// --- Option 1: Export the component directly ---
// Users can import it like: import { CameraRecorder } from 'your-package-name';
export { CameraRecorder };


// --- Option 2: Provide a Vue plugin install function (Recommended) ---
// This allows users to install globally via `app.use(YourPlugin)`
// which registers the component automatically.
const plugin = {
  install: (app, options) => {
    // Register the component globally
    // Use 'CameraRecorder' or a custom name potentially passed via options
    const componentName = options?.componentName || 'CameraRecorder';
    app.component(componentName, CameraRecorder);

    // You could potentially configure the component via options here if needed
    // e.g., app.provide('cameraRecorderOptions', options);
  }
};

// Export the plugin as the default export
export default plugin;

// --- Combining both ---
// You can export both the component and the plugin installer if desired.
// The default export makes `app.use()` work nicely.
// The named export allows users to import the component directly if they prefer.
